<h4 class="card-title">Data Rehab</h4>
<div *ngIf="isLoading">
  <div class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoading">
<div *ngIf="pageData.viewMode=='LIST'" class="row">
  <div class="row">
    <div class="input-field col s12">
      <i class="material-icons prefix">account_circle</i>
      <input [(ngModel)]="pageData.account.email" id="txtName" name="txtName" type="text" />
      <label for="txtName" class="active">Name</label>
    </div>
    <div class="input-field col s12">
      <i class="material-icons prefix">vpn_key</i>
      <input [(ngModel)]="pageData.account.password" id="txtPwd" name="txtPwd" type="password" />
      <label for="txtPwd" class="active">Password</label>
    </div>
    <div class="input-field col s12">
      <i class="material-icons prefix">link</i>
      <input [(ngModel)]="pageData.account.url" id="txtName" name="txtName" type="text" />
      <label for="txtName" class="active">URL</label>
    </div>
    <div class="col s12">
      <button (click)="onSubmit()" class="btn cyan waves-effect waves-light" type="submit" name="action">Submit
        <i class="material-icons right">send</i>
      </button>
    </div>
  </div>
</div>
<div *ngIf="pageData.viewMode=='FORM'">
  <form class="col s12">
    
    <div class="row">
      <!-- <div class="input-field col s12">
        <i class="material-icons prefix">question_answer</i>
        <textarea id="message3" class="materialize-textarea"></textarea>
        <label for="message3">Message</label>
      </div> -->
      <div class="row">
        <div class="input-field col s12">
          
          <button (click)="userList()" class="btn cyan lighten-2 waves-effect waves-light right" type="submit" name="action" style="margin-right: 2px;">Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
</div>
